'use es6';

import { createStack } from '../index';
import { set } from '../helpers/update';
import { retry, onResponse, hubletApi, resolveApi, withUrl, method, environmentUrl, query } from './core';
import { logoutOn, logoutOnError } from './hubapi';
import { buildUrl } from '../helpers/url';
import { redirectTo } from '../helpers/location';
import { Promise } from '../helpers/promise';
import { responseError } from '../helpers/response';
import toggleable from '../decorators/toggleable';
import { maybeGetParentIframe, UNAUTHORIZED_MESSAGE } from '../helpers/iframe';

var recycledResponse = function recycledResponse(response) {
  return response.xhr.readyState === 0 ? {
    status: response.status,
    statusText: response.statusText,
    data: response.data
  } : response.xhr;
};

var withRecycledResponse = function withRecycledResponse(options) {
  return function (response) {
    return set('externalResponse', recycledResponse(response))(options);
  };
};

export var recyclePromise = function recyclePromise(options) {
  if (options.recycledPromise) {
    return options.recycledPromise.then(withRecycledResponse(options), withRecycledResponse(options));
  } else {
    return options;
  }
};

var isUnauthorizedOrForbidden = function isUnauthorizedOrForbidden(response) {
  return response.status === 403 || response.status === 401;
};

export var logoutOnUnauthorizedOrForbidden = function logoutOnUnauthorizedOrForbidden(options) {
  var parentWindow = maybeGetParentIframe();

  if (parentWindow) {
    return onResponse(function (response) {
      if (isUnauthorizedOrForbidden(response)) {
        parentWindow.postMessage(UNAUTHORIZED_MESSAGE, '*');
        return Promise.reject(responseError(response, 'Aborting: notifying parents of unauthorized response'));
      }

      return response;
    })(options);
  }

  return logoutOn(isUnauthorizedOrForbidden)(options);
};
export var retryOnError = retry(function (response) {
  return response.status !== 200 && !isUnauthorizedOrForbidden(response);
}, {
  reason: 'Error fetching user data',
  maxRetries: 3,
  onMaxAttemptsReached: logoutOnError
});
export var portalIdBody = function portalIdBody(options) {
  return set('data', {
    portalId: options.portalId
  })(options);
};

var buildForbiddenUrl = function buildForbiddenUrl(options) {
  var hostname = resolveApi(hubletApi('app', 'hubspot'));
  var portalId = options.portalId || '';
  var dashboardDescriptor = {
    hostname: hostname,
    path: "/account-and-billing/" + portalId + "/forbidden"
  };
  return buildUrl(dashboardDescriptor);
};

var redirectSuspendedHub = function redirectSuspendedHub(response) {
  var options = response.options;
  var redirectUrl = buildForbiddenUrl(options);
  return redirectTo(redirectUrl, options) ? Promise.reject(responseError(response, 'Aborting: redirection in progress')) : response;
};

var shouldRedirectForSuspension = function shouldRedirectForSuspension(response) {
  return !response.options.allowSuspended && response.data.user && Array.isArray(response.data.user.scopes) && response.data.user.scopes.indexOf('suspended') !== -1;
};

export var hubUserInfoEndpointTest = createStack(function (options) {
  return withUrl(function (url) {
    if (url.path === '/login-verify') {
      return Object.assign({}, url, {
        path: '/login-verify/hub-user-info'
      });
    }

    return url;
  })(options);
}, method('GET'), function (options) {
  return environmentUrl(hubletApi('api', 'hubspot', options.hubletOverride))(options);
}, function (options) {
  return query({
    portalId: options.portalId
  })(options);
});
export var redirectSuspendedUsers = toggleable(function (isEnabled) {
  return function (options) {
    if (!isEnabled()) return options;
    return onResponse(function (response) {
      if (shouldRedirectForSuspension(response)) {
        return redirectSuspendedHub(response);
      }

      return response;
    })(options);
  };
});